<div class="card card-default page-compact">
  <div class="card-header title_size">
    <div class="row align-items-center">
      <div class="col-md-6">
        <div class="header-title">
          <h2 class="card-title mb-0">
            <i class="fas fa-building me-2"></i>
            Edit Department Details
          </h2>
        </div>
      </div>
      <div class="col-md-6 d-flex justify-content-end">
        <button type="button" class="btn btn-success submit-btn" (click)="submit()">
          <i class="fas fa-paper-plane me-2"></i>Submit
        </button>
      </div>
    </div>
  </div>


  <div class="card-body">


    <!-- MAIN ROW -->
    <div class="row">

      <!-- ================= LEFT COLUMN ================= -->
      <div class="col-md-6">

        <!-- Foreman -->
        <div class="form-group">
          <label>Select Foreman</label>

          <div class="input-group">
            <input type="search" class="form-control" placeholder="Search employee" [(ngModel)]="foremanSearch"
              (ngModelChange)="onForemanSearch()">

            <button type="submit" class="btn btn-default" (click)="onForemanSearch()">
              <i class="fa fa-search"></i>
            </button>
          </div>

          <!-- Foreman Search Result -->
          <div class="card card-default" *ngIf="showForemanList">
            <div *ngFor="let emp of foremanList">
              <h4 class="font" (click)="selectForeman(emp)">
                <b>{{ emp.employee_name }}</b>
              </h4>
            </div>
          </div>
        </div>

        <!-- Warehouse -->
        <div class="form-group">
          <label>Select Warehouse</label>

          <div class="input-group">
            <input type="search" class="form-control" placeholder="Search Warehouse" [(ngModel)]="warehouseSearch"
              (ngModelChange)="onWarehouseSearchChange()">

            <button type="submit" class="btn btn-default">
              <i class="fa fa-search"></i>
            </button>
          </div>

          <div class="card card-default" *ngIf="showWarehouseList && warehouseSearch">
            <div *ngFor="let w of warehouseList">
              <h4 *ngIf="w.warehouse_name.toLowerCase().includes(warehouseSearch.toLowerCase())" class="font"
                (click)="selectWarehouse(w)">
                <b>{{ w.warehouse_name }}</b>
              </h4>
            </div>
          </div>
        </div>

        <!-- Customers -->
        <!-- <div class="form-group">
          <label>Select Customer</label>
          <div class="input-group">
            <ng-select class="customer-select" [items]="customerList" bindLabel="customer_name" bindValue="customer_id"
              name="customer_id" id="customer_id" [multiple]="true" dropdownPosition="bottom" [closeOnSelect]="false"
              [virtualScroll]="true" [(ngModel)]="model.cash_customers">
            </ng-select>
          </div>
        </div> -->

        <!-- Is Factory & Is Factory Counter Sale (inline) -->
        <div class="form-group">
          <div class="d-flex align-items-center" style="gap: 24px;">
            <mat-checkbox [(ngModel)]="model.is_factory">
              Is Factory
            </mat-checkbox>

            <mat-checkbox [(ngModel)]="model.is_technician_available">
              Is Technician Available
            </mat-checkbox>

            <mat-checkbox [(ngModel)]="model.has_new_product_request">
              is New Product Request Supported
            </mat-checkbox>
          </div>
        </div>
        <!-- Assigned Employee for Sale Order -->
        <!-- Assigned Employee for Sale Order -->
        <div class="form-group mt-3">
          <label class="form-label">New Product ID Creator</label>
          <ng-select [multiple]="false" [clearable]="true" [searchable]="true" dropdownPosition="bottom"
            [items]="allEmployees" bindLabel="employee_name" [(ngModel)]="assignedEmployee"
            (change)="onNewProductIdCreatorChange($event)" placeholder="Select Employee">
          </ng-select>
        </div>
         <div class="row mt-3">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label">Store Responsible</label>
              <ng-select [multiple]="false" [clearable]="true" [searchable]="true" dropdownPosition="bottom"
                [items]="allEmployees" bindLabel="employee_name" [(ngModel)]="selectedStoreResponsible"
                (change)="onStoreResponsibleChange($event)" placeholder="Select Store Responsible">
              </ng-select>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label">Safety Responsible</label>
              <ng-select [multiple]="false" [clearable]="true" [searchable]="true" dropdownPosition="bottom"
                [items]="allEmployees" bindLabel="employee_name" [(ngModel)]="selectedSafetyResponsible"
                (change)="onSafetyResponsibleChange($event)" placeholder="Select Safety Responsible">
              </ng-select>
            </div>
          </div>
        </div>

        
        <!-- Employee Dropdown
<div class="form-group mt-3">
  <div class="row align-items-start">

    <div class="col-md-6">
      <label class="form-label">EMPLOYEES</label>
      <ng-select
        [multiple]="true"
        [clearable]="false"
        [searchable]="true"
        searchPlaceholder="Search Employee here"
        dropdownPosition="bottom"
        [closeOnSelect]="false"
        [items]="allEmployees"
        bindLabel="employee_name"
        [(ngModel)]="selectedEmployees"
        placeholder="Select Employees">
        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
          <span class="text-muted" *ngIf="items.length === 0">Select Employees</span>
          <span class="text-muted" *ngIf="items.length > 0">Search Employee Here :</span>
        </ng-template>
      </ng-select>
    </div>

    <div class="col-md-6">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <label class="form-label">
          SELECTED EMPLOYEES
          <span class="count-badge">({{ selectedEmployees?.length || 0 }})</span>
        </label>
        <button type="button" class="btn btn-sm btn-outline-danger" (click)="selectedEmployees = []">
          <i class="fas fa-trash-alt"></i> Discard All
        </button>
      </div>
      <div class="selected-box">
        <ul>
          <li *ngFor="let emp of selectedEmployees; let i = index"
              style="display:flex; justify-content:space-between; padding: 4px 0;">
            <span>{{ emp.employee_name }}</span>
            <span style="cursor:pointer; color:red;" (click)="selectedEmployees.splice(i, 1)">×</span>
          </li>
        </ul>
      </div>
    </div>

  </div>
</div> -->


        <!-- Members -->
        <div class="form-group action-block">
          <label>Members</label>

          <button mat-mini-fab color="primary" class="action-fab" data-toggle="modal" data-target="#membersModal"
            (click)="memberSearch=''; searchMembers()">
            <mat-icon>add</mat-icon>
          </button>

          <div class="action-list" *ngFor="let emp of model.members">
            <input type="checkbox" class="checkbox-custom" disabled checked>
            {{ emp.employee_name }}
          </div>
        </div>

        <!-- Account Members -->
        <div class="form-group action-block">
          <label>Account Members</label>

          <button mat-mini-fab color="primary" class="action-fab" data-toggle="modal" data-target="#accMembersModal"
            (click)="accMemberSearch=''; searchAccMembers()">
            <mat-icon>add</mat-icon>
          </button>

          <div class="action-list" *ngFor="let emp of model.accounts_members">
            <input type="checkbox" disabled checked>
            {{ emp.employee_name }}
          </div>
        </div>

        <!-- Helper Members -->
        <div class="form-group action-block">
          <label>Helper Members</label>

          <button mat-mini-fab color="primary" class="action-fab" data-toggle="modal" data-target="#helperMembersModal"
            (click)="helperSearch=''; searchHelperMembers()">
            <mat-icon>add</mat-icon>
          </button>

          <div class="action-list" *ngFor="let emp of model.helper_members">
            <input type="checkbox" disabled checked>
            {{ emp.employee_name }}
          </div>
        </div>
        <div class="form-group action-block">
          <label>RFT Technicians</label>

          <button mat-mini-fab color="primary" class="action-fab" data-toggle="modal" data-target="#technicianModal"
            (click)="technicianSearch=''; searchTechnicians()">
            <mat-icon>add</mat-icon>
          </button>

          <div class="action-list" *ngFor="let tech of model.rft_technicians">
            <input type="checkbox" disabled checked>
            {{ tech.technician_name }}
          </div>
        </div>
        <div class="form-group action-block">
          <label>RFT Brands</label>

          <button mat-mini-fab color="primary" class="action-fab" data-toggle="modal" data-target="#brandModal"
            (click)="brandSearch=''; searchBrands()">
            <mat-icon>add</mat-icon>
          </button>

          <div class="action-list" *ngFor="let brand of model.rft_brands">
            <input type="checkbox" disabled checked>
            {{ brand.brand_name }}
          </div>
        </div>
        <div class="form-group action-block">
          <label>Delivery Man/Driver</label>

          <button mat-mini-fab color="primary" class="action-fab" data-toggle="modal" data-target="#deliveryManModal"
            (click)="deliveryManSearch=''; searchDeliveryMen()">
            <mat-icon>add</mat-icon>
          </button>

          <div class="action-list" *ngFor="let d of model.driver_delivery_employees">
            <input type="checkbox" disabled checked>
            {{ d.employee_name }}
          </div>
        </div>
        <!-- Industry Types -->
        <div class="form-group action-block">
          <label>Industry Types</label>

          <button mat-mini-fab color="primary" class="action-fab" data-toggle="modal" data-target="#industryModal">
            <mat-icon>add</mat-icon>
          </button>

          <div class="action-list" *ngFor="let ind of model.industry_types">
            <input type="checkbox" disabled checked>
            {{ ind.industry_type_name }} - {{ ind.estimated_time }}
          </div>
        </div>





      </div>

      <!-- ================= RIGHT COLUMN ================= -->
      <div class="col-md-6">

        <!-- Time Inputs -->
        <!-- <div class="form-group">
          <label>Work In Time</label>
          <input class="form-control" [(ngModel)]="model.work_in_time" [ngxTimepicker]="picker1" [format]="24" readonly>

          <ngx-material-timepicker #picker1></ngx-material-timepicker>
        </div> -->

        <!-- <div class="form-group">
          <label>Lunch Out Time</label>
          <input class="form-control" [(ngModel)]="model.lunch_out_time" [ngxTimepicker]="picker2" [format]="24"
            readonly>
          <ngx-material-timepicker #picker2></ngx-material-timepicker>
        </div> -->

        <!-- <div class="form-group">
          <label>Lunch In Time</label>
          <input class="form-control" [(ngModel)]="model.lunch_in_time" [ngxTimepicker]="picker3" [format]="24"
            readonly>
          <ngx-material-timepicker #picker3></ngx-material-timepicker>
        </div> -->

        <!-- <div class="form-group">
          <label>Work Out Time</label>
          <input class="form-control" [(ngModel)]="model.work_out_time" [ngxTimepicker]="picker4" [format]="24"
            readonly>
          <ngx-material-timepicker #picker4></ngx-material-timepicker>
        </div> -->
        <!-- <div class="form-group">
          <label>Select Brands</label>
          <ng-select [items]="brandList" bindLabel="brand_name" [multiple]="true" [closeOnSelect]="false"
            [(ngModel)]="model.rft_brands">
          </ng-select>
        </div> -->
        <!-- Country -->
        <div class="form-group">
          <label>Select Country</label>
          <ng-select [items]="countries" bindLabel="name" [clearable]="false" [(ngModel)]="selectedCountry"
            (change)="onCountrySelected($event)">
          </ng-select>
        </div>

        <!-- Timezone -->
        <div class="form-group">
          <label>Select Timezone</label>
          <ng-select [items]="timezoneList" [clearable]="false" [(ngModel)]="model.timezone">
          </ng-select>
        </div>

        <!-- Latitude -->
        <div class="form-group">
          <label>Latitude</label>
          <input type="number" class="form-control" [(ngModel)]="model.department_latitude">
        </div>

        <!-- Longitude -->
        <div class="form-group">
          <label>Longitude</label>
          <input type="number" class="form-control" [(ngModel)]="model.department_longitude">
        </div>

        <!-- Open Map -->
        <div>
          <label>Location</label><br>
          <a class="btn-sm edit_style space" data-toggle="modal" data-target="#mapModal">
            <mat-icon>room</mat-icon>
          </a>
        </div>
        <!-- Public Holidays (Full Width) -->
        <div class="row">
          <div class="col-12">
            <div class="form-group mt-4 public-holidays-full">
              <label>Public Holidays</label>

              <div class="holiday-row">
                <input type="date" class="form-control" [(ngModel)]="newHoliday">
                <button class="btn btn-primary btn-sm" (click)="addHoliday()">Add</button>
              </div>

              <select multiple class="form-control mt-2 holiday-select" size="4">
                <option *ngFor="let h of model.public_holidays">{{ h }}</option>
              </select>

              <button class="btn btn-danger btn-sm mt-2" (click)="removeSelectedHoliday()">
                Remove Selected
              </button>
            </div>
          </div>
        </div>

      </div>

    </div>

    <!-- WEEKLY WORKING DAYS (Full Width, row layout) -->
    <div class="row g-4 mt-3">
      <div class="col-md-12">
        <div class="detail-section">
          <div class="d-flex justify-content-between align-items-center section-title">
            <span><i class="fas fa-calendar-week me-2"></i>Weekly Working Days</span>
            <button type="button" class="btn btn-sm btn-outline-primary" (click)="fillAllTimes()">
              <i class="fas fa-copy me-1"></i>Fill All Days
            </button>
          </div>
          <div class="weekdays-grid-list">
            <div *ngFor="let day of weekdays" class="weekday-row">
              <mat-checkbox [checked]="day.checked" (change)="toggleWeekday(day)" class="day-checkbox">
                {{ day.week }}
              </mat-checkbox>

              <div class="day-time-row" *ngIf="day.checked">
                <div class="time-field">
                  <label class="small mb-0 d-block">Work in</label>
                  <input class="form-control form-control-sm" type="time" [(ngModel)]="day.workin_time"
                    [ngModelOptions]="{standalone: true}">
                </div>
                <div class="time-field">
                  <label class="small mb-0 d-block">Work out</label>
                  <input class="form-control form-control-sm" type="time" [(ngModel)]="day.workout_time"
                    [ngModelOptions]="{standalone: true}">
                </div>
                <div class="time-field">
                  <label class="small mb-0 d-block">Lunch in</label>
                  <input class="form-control form-control-sm" type="time" [(ngModel)]="day.lunch_in_time"
                    [ngModelOptions]="{standalone: true}">
                </div>
                <div class="time-field">
                  <label class="small mb-0 d-block">Lunch out</label>
                  <input class="form-control form-control-sm" type="time" [(ngModel)]="day.lunch_out_time"
                    [ngModelOptions]="{standalone: true}">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- GOOGLE MAP -->
    <google-map *ngIf="mapLoaded" height="500px" width="100%" [center]="mapCenter" [zoom]="mapZoom"
      (mapClick)="onMapClick($event)">
      <map-marker *ngFor="let m of mapMarkers" [position]="m.position" [label]="m.label" [options]="m.options">
      </map-marker>
    </google-map>

    <br>

    <!-- Submit -->
    <!-- <button class="btn btn-primary btn_allign" (click)="submit()">Submit</button> -->

  </div>
</div>


<!-- MEMBERS MODAL -->
<div class="modal fade" id="membersModal">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-body" style="height: 480px; overflow-y: auto;">
        <input type="text" class="form-control" placeholder="Search employees" [(ngModel)]="memberSearch"
          (ngModelChange)="searchMembers()">

        <table class="table table-striped mt-3">
          <tbody>
            <tr *ngFor="let emp of memberListFiltered">
              <td>
                <input type="checkbox" [checked]="isMemberSelected(emp)" (change)="toggleMember(emp)">
              </td>
              <td>{{ emp.employee_name }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="modal-footer">
        <button class="btn btn-primary" data-dismiss="modal">Save</button>
        <button class="btn btn-default" data-dismiss="modal">Cancel</button>
      </div>

    </div>
  </div>
</div>


<!-- ACCOUNT MEMBERS MODAL -->
<div class="modal fade" id="accMembersModal">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-body" style="height: 480px; overflow-y: auto;">
        <input type="text" class="form-control" placeholder="Search employees" [(ngModel)]="accMemberSearch"
          (ngModelChange)="searchAccMembers()">

        <table class="table table-striped mt-3">
          <tbody>
            <tr *ngFor="let emp of memberListFiltered">
              <td>
                <input type="checkbox" [checked]="isAccSelected(emp)" (change)="toggleAcc(emp)">
              </td>
              <td>{{ emp.employee_name }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="modal-footer">
        <button class="btn btn-primary" data-dismiss="modal">Save</button>
        <button class="btn btn-default" data-dismiss="modal">Cancel</button>
      </div>

    </div>
  </div>
</div>


<!-- HELPER MEMBERS MODAL -->
<div class="modal fade" id="helperMembersModal">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-body" style="height: 480px; overflow-y: auto;">
        <input type="text" class="form-control" placeholder="Search employees" [(ngModel)]="helperSearch"
          (ngModelChange)="searchHelperMembers()">

        <table class="table table-striped mt-3">
          <tbody>
            <tr *ngFor="let emp of memberListFiltered">
              <td>
                <input type="checkbox" [checked]="isHelperSelected(emp)" (change)="toggleHelper(emp)">
              </td>
              <td>{{ emp.employee_name }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="modal-footer">
        <button class="btn btn-primary" data-dismiss="modal">Save</button>
        <button class="btn btn-default" data-dismiss="modal">Cancel</button>
      </div>

    </div>
  </div>
</div>

<!-- TECHNICIAN MODAL -->
<div class="modal fade" id="technicianModal">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-body" style="height: 480px; overflow-y: auto;">
        <input type="text" class="form-control" placeholder="Search employees" [(ngModel)]="technicianSearch"
          (ngModelChange)="searchTechnicians()">

        <table class="table table-striped mt-3">
          <tbody>
            <tr *ngFor="let emp of memberListFiltered">
              <td>
                <input type="checkbox" [checked]="isTechnicianSelected(emp)" (change)="toggleTechnician(emp)">
              </td>
              <td>{{ emp.employee_name }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="modal-footer">
        <button class="btn btn-primary" data-dismiss="modal">Save</button>
        <button class="btn btn-default" data-dismiss="modal">Cancel</button>
      </div>

    </div>
  </div>
</div>
<!-- BRAND MODAL -->
<div class="modal fade" id="brandModal">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-body" style="height: 480px; overflow-y: auto;">
        <input type="text" class="form-control" placeholder="Search brands" [(ngModel)]="brandSearch"
          (ngModelChange)="searchBrands()">

        <table class="table table-striped mt-3">
          <tbody>
            <tr *ngFor="let brand of brandListFiltered">
              <td>
                <input type="checkbox" [checked]="isBrandSelected(brand)" (change)="toggleBrand(brand)">
              </td>
              <td>{{ brand.brand_name }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="modal-footer">
        <button class="btn btn-primary" data-dismiss="modal">Save</button>
        <button class="btn btn-default" data-dismiss="modal">Cancel</button>
      </div>

    </div>
  </div>
</div>

<!-- DELIVERY MAN MODAL (mock data, API pending) -->
<div class="modal fade" id="deliveryManModal">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-body" style="height: 480px; overflow-y: auto;">
        <input type="text" class="form-control" placeholder="Search delivery men" [(ngModel)]="deliveryManSearch"
          (ngModelChange)="searchDeliveryMen()">

        <table class="table table-striped mt-3">
          <tbody>
            <tr *ngFor="let d of deliveryManListFiltered">
              <td>
                <input type="checkbox" [checked]="isDeliveryManSelected(d)" (change)="toggleDeliveryMan(d)">
              </td>
              <td>{{ d.employee_name }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="modal-footer">
        <button class="btn btn-primary" data-dismiss="modal">Save</button>
        <button class="btn btn-default" data-dismiss="modal">Cancel</button>
      </div>

    </div>
  </div>
</div>


<!-- INDUSTRY MODAL -->
<div class="modal fade" id="industryModal">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-body" style="height: 480px; overflow-y: auto;">

        <input type="text" class="form-control" placeholder="Search types" [(ngModel)]="industrySearch">

        <table class="table table-striped mt-3">
          <tbody>
            <tr *ngFor="let ind of industryList">
              <td>
                <input type="checkbox" [checked]="isIndustrySelected(ind)" (change)="toggleIndustry(ind)">
              </td>
              <td>{{ ind.name }}</td>
            </tr>
          </tbody>
        </table>

      </div>

      <div class="modal-footer">
        <button class="btn btn-primary" data-dismiss="modal">Save</button>
        <button class="btn btn-default" data-dismiss="modal">Cancel</button>
      </div>

    </div>
  </div>
</div>


<!-- INDUSTRY TIME MODAL -->
<div class="modal fade" id="industryTimeModal">
  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3>Time Estimate</h3>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <div class="modal-body">
        <label>Time Estimate (HH:mm:ss)</label>

        <input type="text" class="form-control" [(ngModel)]="industryTime" (input)="validateTime()"
          placeholder="HH:mm:ss">

        <small *ngIf="invalidTime" class="text-danger">Invalid format</small>
      </div>

      <div class="modal-footer">
        <button class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button class="btn btn-primary" [disabled]="invalidTime" (click)="saveIndustryTime()">Save</button>
      </div>

    </div>
  </div>
</div>
<div *ngIf="isLoading" class="loading-overlay">
  <div style="display: flex; flex-direction: column; align-items: center;">
    <!-- COMPLETE SPINNER (logo + ring perfectly aligned) -->
    <div class="custom-spinner">
      <img src="assets/img/logo.png" alt="Logo" class="center-logo">
      <div class="rotating-ring"></div>
    </div>

    <!-- Text below spinner -->
    <p class="loading-text">Updating department details...</p>
  </div>
</div>